import React from 'react';

// The arrow of a drop-down: a right-angled chevron with rounded ends, as Stripe draws it in its own fields, in place of
// antd's flat, sharp one (Vova 29.10.2026). `up` while the list is open.
export function Chevron({
    size = 16,
    up = false,
    color = 'currentColor',
}: {
    size?: number;
    up?: boolean;
    color?: string;
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            style={{ display: 'block', transform: up ? 'rotate(180deg)' : undefined, transition: 'transform 0.2s' }}
        >
            <path d="M6 9l6 6 6-6" />
        </svg>
    );
}
